import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import './App.css'

import HomeScreen from './pages/HomeScreen'
import AdminEmailList from './pages/AdminEmailList'

function App() {
  return (
    <div className="App">
      <Routes>
        {/* Ana sayfa */}
        <Route path="/" element={<HomeScreen />} />

        {/* Admin e-mail listesi */}
        <Route path="/admin-emails" element={<AdminEmailList />} />

        {/* Tanımsız rotalar anasayfaya yönlensin */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  )
}

export default App
